/**
 * Application constants
 */

// API Routes
export const API_ROUTES = {
  AUTH: {
    CSRF: '/auth/csrf/',
    LOGIN: '/auth/login/',
    LOGOUT: '/auth/logout/',
    REFRESH: '/auth/refresh/',
    ME: '/auth/me/',
  },
  USERS: {
    PROFILE: '/users/profile/',
    PROFILE_UPDATE: '/users/profile/update/',
  },
  GADS: {
    LIST: '/gads/',
    ACTIVE: '/gads/active/',
    DETAIL: (id: number) => `/gads/${id}/`,
    SETTINGS: (id: number) => `/gads/${id}/settings/`,
  },
  GAD_MEMBERS: '/gad-members/',
  BUDGETS: '/budget-line-items/',
  PARTIES: '/parties/',
  DOCUMENTS: '/documents/',
  PAYMENT_JUSTIFICATIONS: '/payment-justifications/',
  PAYMENT_JUSTIFICATION_TEMPLATES: '/payment-justification-templates/',
  PAYMENT_JUSTIFICATION_GLOBAL_TEMPLATES: '/payment-justification-global-templates/',
  EMPLOYEES: '/employees/',
  PAYROLLS: '/payrolls/',
  PAYROLL_TEMPLATES: '/payroll-templates/',
  PAYROLL_GLOBAL_TEMPLATES: '/payroll-global-templates/',
  CHOICES: (appLabel: string, modelName: string, fieldName: string) =>
    `/choices/${appLabel}/${modelName}/${fieldName}/`,
} as const;

// App Routes (Spanish)
export const APP_ROUTES = {
  HOME: '/',
  SIGNIN: '/iniciar-sesion',
  FORBIDDEN: '/acceso-denegado',
  NOT_FOUND: '/no-encontrado',
  DASHBOARD: '/',
  BUDGETS: '/partidas-presupuestarias',
  PARTIES: '/terceros',
  PAYMENT_JUSTIFICATIONS: {
    ROOT: '/justificaciones-pago',
    GENERAL: (id: string | number) => `/justificaciones-pago/${id}/general`,
    BENEFICIARIES: (id: string | number) => `/justificaciones-pago/${id}/beneficiarios`,
  },
  EMPLOYEES: '/empleados',
  PAYROLLS: '/roles-pago',
  SETTINGS: {
    ROOT: '/configuraciones',
    GENERAL: '/configuraciones/general',
    MEMBERS: '/configuraciones/directorio',
    PARAMETERS: '/configuraciones/parametros',
    BUDGET_MAPPINGS: '/configuraciones/partidas',
    BANK_ACCOUNTS: '/configuraciones/cuentas-bancarias',
    TEMPLATES: '/configuraciones/plantillas',
  },
  PROFILE: {
    ROOT: '/perfil',
    PERSONAL: '/perfil/datos-personales',
  },
} as const;

// Query Keys for React Query
export const QUERY_KEYS = {
  AUTH: {
    USER: ['auth', 'user'],
  },
  PROFILE: ['profile'],
  BUDGETS: {
    ALL: ['budgets'],
    DETAIL: (id: string) => ['budgets', id],
  },
  PARTIES: {
    ALL: ['parties'],
    DETAIL: (id: string) => ['parties', id],
  },
  PAYMENT_JUSTIFICATIONS: {
    ALL: ['payment-justifications'],
    DETAIL: (id: string) => ['payment-justifications', id],
  },
  PAYROLLS: {
    ALL: ['payrolls'],
    DETAIL: (id: string) => ['payrolls', id],
  },
  CHOICES: (appLabel: string, modelName: string, fieldName: string) => ['choices', appLabel, modelName, fieldName],
} as const;

// Pagination defaults
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

// Title options for individuals (parties, employees, gad members)
export const TITLE_OPTIONS = [
  { value: '', label: 'Sin título' },
  { value: 'Sr.', label: 'Sr.' },
  { value: 'Sra.', label: 'Sra.' },
  { value: 'Srta.', label: 'Srta.' },
  { value: 'Lcdo.', label: 'Lcdo.' },
  { value: 'Lcda.', label: 'Lcda.' },
  { value: 'Ing.', label: 'Ing.' },
  { value: 'Dr.', label: 'Dr.' },
  { value: 'Dra.', label: 'Dra.' },
  { value: 'Arq.', label: 'Arq.' },
  { value: 'Abg.', label: 'Abg.' },
  { value: 'Econ.', label: 'Econ.' },
  { value: 'Msc.', label: 'Msc.' },
  { value: 'PhD.', label: 'PhD.' },
] as const;
